import { ReadonlyRecord } from '@paragon/utilities';

/**
 * Similar to `groupBy`, but ensures that all referenced items exist in the mapping.
 */
export function createMappingByKey<TItem>(
  items: ReadonlyRecord<string, TItem>,
  getKeyFromItem: (item: TItem) => string | null | undefined,
  referencedItems: ReadonlyRecord<string, unknown>,
): ReadonlyRecord<string, readonly TItem[]> {
  const mapping: Record<string, TItem[]> = Object.fromEntries(Object.keys(referencedItems).map((key) => [key, []]));

  for (const item of Object.values(items)) {
    const key = getKeyFromItem(item);
    if (key == null) continue;

    if (!Object.hasOwn(mapping, key)) mapping[key] = [];

    mapping[key].push(item);
  }

  return mapping;
}
